
import { Search } from "vant";
import { number } from "echarts";
import { getMapInfo } from "@/apis/envmonitor";
import { defineComponent, nextTick, onMounted, reactive, toRefs } from "vue";
import { parseImgUrl } from "@/utils";
import { swiper } from "@/utils/swiper";

export default defineComponent({
  components: {
    VanSearch: Search,
  },
  setup() {
    let spaceList: any = [];
    let ctx: any = {};
    let centerObj: any = {};
    const proxyData = reactive({
      spaceList: spaceList,
      copySpaceArr: spaceList,
      parseImgUrl: parseImgUrl,
      spaceName: "",
      width: 3361.136,
      height: 2729.25,
      scale: 1,
      ctx: ctx,
      centerObj: centerObj,
      // 搜索某个空间
      searchSpace() {
        proxyData.spaceList.map((item: any) => {
          // debugger
          console.log(item.localName == proxyData.spaceName);
          console.log("搜索====");
          console.log(item.localName);
          console.log(proxyData.spaceName);
          if (item.localName == proxyData.spaceName) {
            console.log("搜索到某个空间");
            item.fillColor = "red";
            item.shadow = true;
            proxyData.initCanvas();
          } else {
            // item.shadow = false;
            // item.fillColor = "#ececec";
          }
        });
      },
      // 放大
      zommAdd() {
        console.log("被点击了");
        if (proxyData.scale > 3) {
          return;
        }
        proxyData.scale = proxyData.scale + 0.1;
        // debugger;
        proxyData.formSpaceData();
        proxyData.initCanvas();
      },
      // 缩小
      zommDel() {
        if (proxyData.scale < 0.3) {
          return;
        }
        proxyData.scale = proxyData.scale - 0.1;
        proxyData.formSpaceData();
        proxyData.initCanvas();
      },
      sliderSwiper() {
        // 获取当前时间的下标
        let sliderList: any = document.querySelector("#sliderListId");
        sliderList.addEventListener("touchstart", function (e: any) {});
        swiper(sliderList, {
          swipeLeft: function (e: any) {},
          swipeRight: function (e: any) {},
        });
      },
      // canvas画图
      initCanvas() {
        let canvasDom: any = document.querySelector("#myCanvas");
        // canvasDom.width = proxyData.width * proxyData.scale;
        // canvasDom.height = proxyData.height * proxyData.scale;
        let ctx: any = canvasDom.getContext("2d");
        proxyData.drawDpiBegin(
          canvasDom,
          ctx,
          proxyData.width,
          proxyData.height
        );
        proxyData.ctx = ctx;
        ctx.clearRect(0, 0, proxyData.width, proxyData.height);
        ctx.scale(
          proxyData.scale,
          proxyData.scale,
          centerObj.left,
          centerObj.top
        );

        proxyData.spaceList.map((item: any) => {
          if (item.canClick) {
            let circleArr: any = item.circlePoint;
            ctx.beginPath();
            ctx.fillStyle = item.fillColor;
            let pointLeftArr: any = [];
            let pointTopArr: any = [];

            item.pointArr.map((childItem: any, index: any) => {
              // debugger
              childItem.left = childItem.left;
              childItem.top = childItem.top;
              if (index == 0) {
                ctx.moveTo(childItem.left, childItem.top);
              } else {
                ctx.lineTo(childItem.left, childItem.top);
              }
              pointLeftArr.push(childItem.left);
              pointTopArr.push(childItem.top);
            });
            // debugger;
            console.log(item.devicePoint);
            proxyData.drawIcon(ctx, "coffee.svg", item.devicePoint[0]);
            proxyData.drawIcon(ctx, "dev.svg", item.devicePoint[1]);
            proxyData.drawIcon(ctx, "deviceroom.svg", item.devicePoint[2]);
            ctx.closePath();
            ctx.fill();
            ctx.lineWidth = 1;
            ctx.strokeStyle = "rgba(15, 206, 233, 1)";
            ctx.stroke();
            ctx.beginPath();
            if (circleArr && circleArr.length) {
              console.log(circleArr);
              ctx.lineTo(circleArr[3].left, circleArr[3].top);
              ctx.bezierCurveTo(
                circleArr[2].left,
                circleArr[2].top,
                circleArr[1].left,
                circleArr[1].top,
                circleArr[0].left,
                circleArr[0].top
              );
            }
            ctx.closePath();
            ctx.fill();
            ctx.lineWidth = 1;
            ctx.strokeStyle = "rgba(15, 206, 233, 1)";
            ctx.stroke();

            let min1: any =
              proxyData.MaxAndMin(pointLeftArr)[1] -
              proxyData.MaxAndMin(pointLeftArr)[0];
            let min2: any =
              proxyData.MaxAndMin(pointTopArr)[1] -
              proxyData.MaxAndMin(pointTopArr)[0];
            let min: any = min1 < min2 ? min1 : min2;
            ctx.beginPath();
            ctx.font = "13px serif";
            ctx.textAlign = "center";
            ctx.fillStyle = item.fillColor !== "#ececec" ? "#ffffff" : "red";
            console.log("min===" + min);
            if (item.localName && min > 100) {
              ctx.fillText(
                item.localName,
                item.logPointArr[0].left,
                item.logPointArr[0].top,
                item.width
              );
            }
            ctx.closePath();
            if (item.shadow) {
              item.shadowColor = "#000000";
              ctx.shadowOffsetX = -50; //阴影x轴位移。正值向右，负值向左。
              ctx.shadowOffsetY = -50; //阴影y轴位移。正值向下，负值向上。
              ctx.shadowBlur = 10; //阴影模糊滤镜。数据越大，扩散程度越大。
            }
          } else {
            let img: any = new Image();
            img.src = require("@/assets/svg/bg_disable.png");
            img.onload = function () {
              ctx.beginPath();
              item.pointArr.map((item: any, index: any) => {
                if (index === 0) {
                  ctx.moveTo(item.left, item.top);
                } else {
                  ctx.lineTo(item.left, item.top);
                }
              });
              //   ctx.fillStyle = "#cfefef";
              //   ctx.fill();
              let pat: any = ctx.createPattern(img, "repeat");
              ctx.fillStyle = pat;
              ctx.fill();
              ctx.closePath();
              ctx.strokeStyle = "rgba(15, 206, 233, 1)";
              ctx.stroke();
            };
          }
        });
        proxyData.drawDpiEnd(canvasDom,ctx)
      },
      MaxAndMin(arr: any) {
        return [Math.min.apply(null, arr), Math.max.apply(null, arr)];
      },
      // 绑定事件
      bindEvent() {
        let canvasDom: any = document.querySelector("#myCanvas");
        // 点击事件
        canvasDom.addEventListener("click", proxyData.detect);
      },
      // 解决canvas画图模糊的问题
      // 开始画
      drawDpiBegin(dom: any, context: any, width: any, height: any) {
        context.save();
        let scaleValue = window.devicePixelRatio;
        dom.setAttribute("width", width * scaleValue);
        dom.setAttribute("height", height * scaleValue);

        dom.style.width = width + "px";
        dom.style.height = height + "px";
        context.scale(scaleValue, scaleValue);
      },
      // 画图介绍
      drawDpiEnd(dom: any, context: any) {
        context.restore();
      },
      // 地图点击事件
      detect(event: any) {
        let canvasDom: any = document.querySelector("#myCanvas");
        let x: any = event.clientX - canvasDom.getBoundingClientRect().left;
        let y: any = event.clientY - canvasDom.getBoundingClientRect().top;
        //   let ctx: any = canvasDom.getContext("2d");
        // proxyData.initCanvas();
        console.log(event);
        // alert("点击了!");
        for (let i = 0; i < proxyData.spaceList.length; i++) {
          let item: any = proxyData.spaceList[i];
          let devicePoint: any = item.devicePoint;
          let pointArr: any = item.pointArr;
          let iconFlag: any = false;
          devicePoint.map((dev: any, index: any) => {
            if (
              x >= dev.left &&
              x <= dev.left + 20 &&
              y >= dev.top &&
              y < dev.top + 20
            ) {
              // alert("我被点了!");
              // console.log("我被点了!")
              iconFlag = true;
              console.log(`我被点了设备图标!${index}`);
            }
          });
          if (iconFlag) {
            break;
          }
          let dot: any = {
            x: x,
            y: y,
          };
          let coordinates: any = pointArr;
          coordinates.map((item: any) => {
            item.x = item.left;
            item.y = item.top;
          });
          let flag = proxyData.queryPtInPolygon(dot, coordinates);
          // console.log(flag);
          if (flag) {
            console.log("点击了区域" + item.localName);
            break;
          }
        }
      },
      queryPtInPolygon(point: any, polygon: any) {
        let p1: any = "";
        let p2: any = "";
        let p3: any = "";
        let p4: any = "";

        p1 = point;
        p2 = { x: 1000000000000, y: point.y };

        let count: any = 0;
        //对每条边都和射线作对比
        for (let i = 0; i < polygon.length - 1; i++) {
          p3 = polygon[i];
          p4 = polygon[i + 1];
          if (checkCross(p1, p2, p3, p4) == true) {
            count++;
          }
        }
        p3 = polygon[polygon.length - 1];

        p4 = polygon[0];
        if (checkCross(p1, p2, p3, p4) == true) {
          count++;
        }

        return count % 2 == 0 ? false : true;

        //判断两条线段是否相交
        function checkCross(p1: any, p2: any, p3: any, p4: any) {
          let v1: any = { x: p1.x - p3.x, y: p1.y - p3.y };
          let v2: any = { x: p2.x - p3.x, y: p2.y - p3.y };

          let v3: any = { x: p4.x - p3.x, y: p4.y - p3.y };
          let v: any = crossMul(v1, v3) * crossMul(v2, v3);

          v1 = { x: p3.x - p1.x, y: p3.y - p1.y };
          v2 = { x: p4.x - p1.x, y: p4.y - p1.y };

          v3 = { x: p2.x - p1.x, y: p2.y - p1.y };
          return v <= 0 && crossMul(v1, v3) * crossMul(v2, v3) <= 0
            ? true
            : false;
        }

        //计算向量叉乘
        function crossMul(v1: any, v2: any) {
          return v1.x * v2.y - v1.y * v2.x;
        }
      },
      // 画图标
      drawIcon(ctx: any, url: any, iconPerstion: any) {
        if (iconPerstion) {
          let img: any = new Image();
          img.src = require(`@/assets/svg/${url}`);
          img.onload = function () {
            ctx.drawImage(img, iconPerstion.left, iconPerstion.top, 25, 15);
            iconPerstion.width = 30;
            iconPerstion.height = 30;
          };
        }
      },
      // 设置区域颜色
      setSpaceColor() {
        proxyData.spaceList.map((item: any, index: any) => {
          if (index % 2 == 0) {
            item.fillColor = "#ffcc33";
          } else if (index % 3 == 0) {
            item.fillColor = "#ccff99";
          } else {
            item.fillColor = "#ececec";
          }
        });
        console.log(proxyData.spaceList);
      },
      // 数据格式化
      formSpaceData() {
        proxyData.spaceList = JSON.parse(proxyData.copySpaceArr);

        proxyData.spaceList.map((item: any) => {
          item.canClick = true;
          item.fillColor = "#ececec";
          // debugger
          item.devicePoint.map((dev: any) => {
            dev.left = dev.left * proxyData.scale;
            dev.top = (proxyData.height - dev.top) * proxyData.scale;
          });
          item.logPointArr.map((dev: any) => {
            dev.left = dev.left * proxyData.scale;
            dev.top = (proxyData.height - dev.top) * proxyData.scale;
          });
          item.pointArr.map((dev: any) => {
            dev.left = dev.left * proxyData.scale;
            dev.top = (proxyData.height - dev.top) * proxyData.scale;
          });
          item.circlePoint.map((dev: any) => {
            dev.left = dev.left * proxyData.scale;
            dev.top = (proxyData.height - dev.top) * proxyData.scale;
          });
        });
      },
      // 格式化地图数据
      formatePage() {
        let spaceList: any = [
          {
            spaceId: "J303",
            localName: "J303",
            canClick: true,
            pointArr: [
              {
                left: "1946.764",
                top: "1087.086",
              },
              {
                left: "2005.1",
                top: "1028.749",
              },
              {
                left: "2117.354",
                top: "1141.002",
              },
              {
                left: "2059.017",
                top: "1199.339",
              },
            ],
            devicePoint: [
              {
                left: "2077.39",
                top: "1144.253",
              },
              {
                left: "2051.563",
                top: "1144.253",
              },
              {
                left: "2026.728",
                top: "1144.253",
              },
            ],
            circlePoint: [],
            logPointArr: [
              {
                left: "2021.762",
                top: "1097.565",
              },
              {
                left: "2021.762",
                top: "1120.412",
              },
            ],
          },
          {
            spaceId: "H306",
            localName: "H306",
            canClick: true,
            pointArr: [
              {
                left: "830.6358",
                top: "948",
              },
              {
                left: "830.6358",
                top: "791.125",
              },
              {
                left: "717.4568",
                top: "791.125",
              },
              {
                left: "644.6346",
                top: "863.9459",
              },
              {
                left: "644.6346",
                top: "948",
              },
            ],
            devicePoint: [
              {
                left: "796.9057",
                top: "922.0877",
              },
              {
                left: "763.7936",
                top: "922.0877",
              },
              {
                left: "728.2287",
                top: "922.0877",
              },
            ],
            circlePoint: [],
            logPointArr: [
              {
                left: "728.2287",
                top: "855.1661",
              },
              {
                left: "728.2287",
                top: "885.1655",
              },
            ],
          },
          {
            spaceId: "H307",
            localName: "H307",
            canClick: true,
            pointArr: [
              {
                left: "550.8858",
                top: "1205.413",
              },
              {
                left: "801.6358",
                top: "1205.413",
              },
              {
                left: "801.6356",
                top: "953",
              },
              {
                left: "566.7966",
                top: "953",
              },
              {
                left: "550.8863",
                top: "968.91",
              },
              {
                left: "550.8863",
                top: "982.1054",
              },
            ],
            devicePoint: [
              {
                left: "759.4864",
                top: "1182.355",
              },
              {
                left: "724.5347",
                top: "1182.355",
              },
              {
                left: "685.2907",
                top: "1182.355",
              },
            ],
            circlePoint: [],
            logPointArr: [
              {
                left: "668.1215",
                top: "1079.339",
              },
              {
                left: "668.1215",
                top: "1111.838",
              },
            ],
          },
          {
            spaceId: "J302",
            localName: "J302",
            canClick: true,
            pointArr: [
              {
                left: "2091.794",
                top: "1028.029",
              },
              {
                left: "2091.794",
                top: "1052.863",
              },
              {
                left: "2145.435",
                top: "1082.168",
              },
              {
                left: "2120.105",
                top: "1082.168",
              },
            ],
            devicePoint: [
              {
                left: "2184.529",
                top: "1073.827",
              },
              {
                left: "2126.192",
                top: "1132.164",
              },
              {
                left: "2094.277",
                top: "1082.168",
              },
            ],
            circlePoint: [],
            logPointArr: [
              {
                left: "2013.939",
                top: "1019.91",
              },
              {
                left: "2072.276",
                top: "961.5741",
              },
            ],
          },
          {
            spaceId: "H305",
            localName: "H305",
            canClick: true,
            pointArr: [
              {
                left: "830.6358",
                top: "656.474",
              },
              {
                left: "830.6358",
                top: "390.0002",
              },
              {
                left: "644.6346",
                top: "390.0002",
              },
              {
                left: "644.6346",
                top: "656.4696",
              },
            ],
            devicePoint: [
              {
                left: "796.9057",
                top: "625.9879",
              },
              {
                left: "763.7936",
                top: "625.9879",
              },
              {
                left: "728.2287",
                top: "625.9879",
              },
            ],
            circlePoint: [],
            logPointArr: [
              {
                left: "728.2287",
                top: "525.304",
              },
              {
                left: "728.2287",
                top: "559.37",
              },
            ],
          },
          {
            spaceId: "J301",
            localName: "J301",
            canClick: true,
            pointArr: [
              {
                left: "2146.522",
                top: "887.3279",
              },
              {
                left: "2196.725",
                top: "837.125",
              },
              {
                left: "2255.418",
                top: "837.125",
              },
              {
                left: "2281.636",
                top: "863.343",
              },
              {
                left: "2281.636",
                top: "976.7202",
              },
              {
                left: "2258.775",
                top: "999.5811",
              },
            ],
            devicePoint: [
              {
                left: "2262.196",
                top: "936.7435",
              },
              {
                left: "2240.471",
                top: "936.7435",
              },
              {
                left: "2217.942",
                top: "936.7435",
              },
            ],
            circlePoint: [],
            logPointArr: [
              {
                left: "2230.011",
                top: "894.0984",
              },
              {
                left: "2230.011",
                top: "914.6163",
              },
            ],
          },
          {
            spaceId: "J305",
            localName: "J305",
            canClick: true,
            pointArr: [
              {
                left: "1881.357",
                top: "1152.493",
              },
              {
                left: "1939.693",
                top: "1094.157",
              },
              {
                left: "2051.946",
                top: "1206.41",
              },
              {
                left: "1993.61",
                top: "1264.746",
              },
            ],
            devicePoint: [
              {
                left: "2012.127",
                top: "1209.928",
              },
              {
                left: "1986.781",
                top: "1209.928",
              },
              {
                left: "1961.838",
                top: "1209.928",
              },
            ],
            circlePoint: [],
            logPointArr: [
              {
                left: "1958.217",
                top: "1167.686",
              },
              {
                left: "1958.217",
                top: "1187.399",
              },
            ],
          },
          {
            spaceId: "H301",
            localName: "H301",
            canClick: true,
            pointArr: [],
            devicePoint: [],
            circlePoint: [],
            logPointArr: [],
          },
          {
            spaceId: "J306",
            localName: "J306",
            canClick: true,
            pointArr: [
              {
                left: "1791.201",
                top: "1242.649",
              },
              {
                left: "1872.518",
                top: "1161.332",
              },
              {
                left: "1984.771",
                top: "1273.585",
              },
              {
                left: "1903.454",
                top: "1354.902",
              },
            ],
            devicePoint: [
              {
                left: "1920.411",
                top: "1293.763",
              },
              {
                left: "1892.204",
                top: "1293.763",
              },
              {
                left: "1864.61",
                top: "1293.763",
              },
            ],
            circlePoint: [],
            logPointArr: [
              {
                left: "1879.94",
                top: "1239.189",
              },
              {
                left: "1879.94",
                top: "1262.49",
              },
            ],
          },
          {
            spaceId: "H303",
            localName: "H303",
            canClick: true,
            pointArr: [
              {
                left: "830.6358",
                top: "385",
              },
              {
                left: "830.6358",
                top: "275.375",
              },
              {
                left: "559.8858",
                top: "275.375",
              },
              {
                left: "559.8858",
                top: "385",
              },
            ],
            devicePoint: [
              {
                left: "796.9057",
                top: "360.6687",
              },
              {
                left: "763.7936",
                top: "360.6687",
              },
              {
                left: "728.2287",
                top: "360.6687",
              },
            ],
            circlePoint: [],
            logPointArr: [
              {
                left: "685.3056",
                top: "311.6137",
              },
              {
                left: "685.3056",
                top: "334.9148",
              },
            ],
          },
          {
            spaceId: "K308",
            localName: "K308",
            canClick: true,
            pointArr: [
              {
                left: "1881.357",
                top: "1576.757",
              },
              {
                left: "1939.693",
                top: "1635.093",
              },
              {
                left: "2051.946",
                top: "1522.84",
              },
              {
                left: "1993.61",
                top: "1464.504",
              },
            ],
            devicePoint: [
              {
                left: "1969.553",
                top: "1585.234",
              },
              {
                left: "1946.865",
                top: "1585.234",
              },
              {
                left: "1921.725",
                top: "1585.234",
              },
            ],
            circlePoint: [],
            logPointArr: [
              {
                left: "1957.29",
                top: "1542.924",
              },
              {
                left: "1957.29",
                top: "1561.32",
              },
            ],
          },
          {
            spaceId: "H302",
            localName: "H302",
            canClick: true,
            pointArr: [
              {
                left: "554.8845",
                top: "384.9999",
              },
              {
                left: "554.8858",
                top: "275.375",
              },
              {
                left: "295.3858",
                top: "275.375",
              },
              {
                left: "295.3858",
                top: "385",
              },
            ],
            devicePoint: [
              {
                left: "509.3208",
                top: "360.6687",
              },
              {
                left: "475.5955",
                top: "360.6687",
              },
              {
                left: "442.4834",
                top: "360.6687",
              },
            ],
            circlePoint: [],
            logPointArr: [
              {
                left: "412.4372",
                top: "311.6137",
              },
              {
                left: "412.4372",
                top: "334.9148",
              },
            ],
          },
          {
            spaceId: "Z305",
            localName: "Z305",
            canClick: true,
            pointArr: [
              {
                left: "1266.174",
                top: "1194.919",
              },
              {
                left: "1374.008",
                top: "1087.086",
              },
              {
                left: "1315.671",
                top: "1028.749",
              },
              {
                left: "1207.837",
                top: "1136.583",
              },
            ],
            devicePoint: [
              {
                left: "1286.004",
                top: "1135.809",
              },
              {
                left: "1265.474",
                top: "1135.809",
              },
              {
                left: "1246.247",
                top: "1135.809",
              },
            ],
            circlePoint: [],
            logPointArr: [
              {
                left: "1278.835",
                top: "1102.244",
              },
              {
                left: "1278.835",
                top: "1118.537",
              },
            ],
          },
          {
            spaceId: "Z306",
            localName: "Z306",
            canClick: true,
            pointArr: [
              {
                left: "1533.99",
                top: "1247.068",
              },
              {
                left: "1448.254",
                top: "1161.332",
              },
              {
                left: "1340.42",
                top: "1269.166",
              },
              {
                left: "1426.157",
                top: "1354.902",
              },
            ],
            devicePoint: [
              {
                left: "1460.698",
                top: "1276.037",
              },
              {
                left: "1427.586",
                top: "1276.037",
              },
              {
                left: "1392.021",
                top: "1276.037",
              },
            ],
            circlePoint: [],
            logPointArr: [
              {
                left: "1427.586",
                top: "1231.274",
              },
              {
                left: "1427.586",
                top: "1252.122",
              },
            ],
          },
          {
            spaceId: "K309",
            localName: "K309",
            canClick: true,
            pointArr: [
              {
                left: "2005.1",
                top: "1700.501",
              },
              {
                left: "2117.354",
                top: "1588.248",
              },
              {
                left: "2059.017",
                top: "1529.911",
              },
              {
                left: "1946.764",
                top: "1642.164",
              },
            ],
            devicePoint: [
              {
                left: "2042.33",
                top: "1644.065",
              },
              {
                left: "2011.292",
                top: "1644.065",
              },
              {
                left: "1981.768",
                top: "1644.065",
              },
            ],
            circlePoint: [],
            logPointArr: [
              {
                left: "2029.461",
                top: "1598.644",
              },
              {
                left: "2029.461",
                top: "1619.083",
              },
            ],
          },
          {
            spaceId: "Z302",
            localName: "Z302",
            canClick: true,
            pointArr: [
              {
                left: "1133.591",
                top: "1062.337",
              },
              {
                left: "1241.425",
                top: "954.5031",
              },
              {
                left: "1183.089",
                top: "896.1668",
              },
              {
                left: "1075.255",
                top: "1004.001",
              },
            ],
            devicePoint: [
              {
                left: "1160.972",
                top: "1007.883",
              },
              {
                left: "1135.626",
                top: "1007.883",
              },
              {
                left: "1113.097",
                top: "1007.883",
              },
            ],
            circlePoint: [],
            logPointArr: [
              {
                left: "1150.512",
                top: "968.8585",
              },
              {
                left: "1150.512",
                top: "987.7672",
              },
            ],
          },
          {
            spaceId: "Z303",
            localName: "Z303",
            canClick: true,
            pointArr: [
              {
                left: "1198.999",
                top: "1127.744",
              },
              {
                left: "1306.832",
                top: "1019.91",
              },
              {
                left: "1248.496",
                top: "961.5741",
              },
              {
                left: "1140.662",
                top: "1069.408",
              },
            ],
            devicePoint: [
              {
                left: "1227.238",
                top: "1065.557",
              },
              {
                left: "1203.099",
                top: "1065.557",
              },
              {
                left: "1181.777",
                top: "1065.557",
              },
            ],
            circlePoint: [],
            logPointArr: [
              {
                left: "1213.559",
                top: "1028.142",
              },
              {
                left: "1213.559",
                top: "1044.235",
              },
            ],
          },
          {
            spaceId: "Z301",
            localName: "Z301",
            canClick: true,
            pointArr: [
              {
                left: "1066.416",
                top: "995.1617",
              },
              {
                left: "1160.108",
                top: "901.4701",
              },
              {
                left: "1174.25",
                top: "887.3279",
              },
              {
                left: "1124.047",
                top: "837.125",
              },
              {
                left: "1065.354",
                top: "837.125",
              },
              {
                left: "1039.136",
                top: "863.343",
              },
              {
                left: "1039.136",
                top: "967.8819",
              },
            ],
            devicePoint: [
              {
                left: "1105.957",
                top: "925.3431",
              },
              {
                left: "1082.116",
                top: "925.3431",
              },
              {
                left: "1057.282",
                top: "925.3431",
              },
            ],
            circlePoint: [],
            logPointArr: [
              {
                left: "1082.116",
                top: "889.582",
              },
              {
                left: "1082.116",
                top: "906.9659",
              },
            ],
          },
          {
            spaceId: "K301",
            localName: "K301",
            canClick: true,
            pointArr: [
              {
                left: "1306.832",
                top: "1709.34",
              },
              {
                left: "1198.999",
                top: "1601.506",
              },
              {
                left: "1140.662",
                top: "1659.842",
              },
              {
                left: "1248.496",
                top: "1767.676",
              },
            ],
            devicePoint: [
              {
                left: "1262.545",
                top: "1714.478",
              },
              {
                left: "1239.613",
                top: "1714.478",
              },
              {
                left: "1217.486",
                top: "1714.478",
              },
            ],
            circlePoint: [],
            logPointArr: [
              {
                left: "1217.486",
                top: "1668.212",
              },
              {
                left: "1217.486",
                top: "1689.937",
              },
            ],
          },
          {
            spaceId: "K302",
            localName: "K302",
            canClick: true,
            pointArr: [
              {
                left: "1315.671",
                top: "1700.501",
              },
              {
                left: "1374.008",
                top: "1642.164",
              },
              {
                left: "1266.174",
                top: "1534.331",
              },
              {
                left: "1207.837",
                top: "1592.667",
              },
            ],
            devicePoint: [
              {
                left: "1337.29",
                top: "1646.145",
              },
              {
                left: "1310.469",
                top: "1646.145",
              },
              {
                left: "1283.152",
                top: "1646.145",
              },
            ],
            circlePoint: [],
            logPointArr: [
              {
                left: "1283.152",
                top: "1603.927",
              },
              {
                left: "1283.152",
                top: "1623.794",
              },
            ],
          },
          {
            spaceId: "K303",
            localName: "K303",
            canClick: true,
            pointArr: [
              {
                left: "1345.449",
                top: "1555.283",
              },
              {
                left: "1391.715",
                top: "1579.422",
              },
              {
                left: "1369.185",
                top: "1579.422",
              },
              {
                left: "1345.449",
                top: "1579.422",
              },
            ],
            devicePoint: [
              {
                left: "1273.245",
                top: "1527.26",
              },
              {
                left: "1381.079",
                top: "1635.093",
              },
              {
                left: "1345.449",
                top: "1535.972",
              },
            ],
            circlePoint: [],
            logPointArr: [
              {
                left: "1439.415",
                top: "1576.757",
              },
              {
                left: "1331.581",
                top: "1468.923",
              },
            ],
          },
          {
            spaceId: "K307",
            localName: "K307",
            canClick: true,
            pointArr: [
              {
                left: "1872.518",
                top: "1567.918",
              },
              {
                left: "1984.771",
                top: "1455.665",
              },
              {
                left: "1903.454",
                top: "1374.348",
              },
              {
                left: "1791.201",
                top: "1486.601",
              },
            ],
            devicePoint: [
              {
                left: "1896.068",
                top: "1509.388",
              },
              {
                left: "1871.843",
                top: "1509.388",
              },
              {
                left: "1846.105",
                top: "1509.388",
              },
            ],
            circlePoint: [],
            logPointArr: [
              {
                left: "1871.843",
                top: "1457.91",
              },
              {
                left: "1871.843",
                top: "1479.864",
              },
            ],
          },
          {
            spaceId: "K306",
            localName: "K306",
            canClick: true,
            pointArr: [
              {
                left: "1733.685",
                top: "1570.507",
              },
              {
                left: "1733.685",
                top: "1450.425",
              },
              {
                left: "1587.086",
                top: "1450.425",
              },
              {
                left: "1587.086",
                top: "1570.507",
              },
            ],
            devicePoint: [
              {
                left: "1706.092",
                top: "1554.085",
              },
              {
                left: "1688.169",
                top: "1554.085",
              },
              {
                left: "1669.594",
                top: "1554.085",
              },
            ],
            circlePoint: [],
            logPointArr: [
              {
                left: "1660.386",
                top: "1504.227",
              },
              {
                left: "1660.386",
                top: "1519.543",
              },
            ],
          },
          {
            spaceId: "K310",
            localName: "K310",
            canClick: true,
            pointArr: [
              {
                left: "2013.939",
                top: "1709.34",
              },
              {
                left: "2072.276",
                top: "1767.676",
              },
              {
                left: "2184.529",
                top: "1655.423",
              },
              {
                left: "2126.192",
                top: "1597.086",
              },
            ],
            devicePoint: [
              {
                left: "2102.611",
                top: "1716.434",
              },
              {
                left: "2076.287",
                top: "1715.938",
              },
              {
                left: "2050.956",
                top: "1715.938",
              },
            ],
            circlePoint: [],
            logPointArr: [
              {
                left: "2098.638",
                top: "1669.746",
              },
              {
                left: "2098.638",
                top: "1689.614",
              },
            ],
          },
          {
            spaceId: "K305",
            localName: "K305",
            canClick: true,
            pointArr: [
              {
                left: "1448.254",
                top: "1567.918",
              },
              {
                left: "1533.99",
                top: "1482.182",
              },
              {
                left: "1426.157",
                top: "1374.348",
              },
              {
                left: "1340.42",
                top: "1460.084",
              },
            ],
            devicePoint: [
              {
                left: "1467.209",
                top: "1505.718",
              },
              {
                left: "1441.461",
                top: "1505.718",
              },
              {
                left: "1415.31",
                top: "1505.718",
              },
            ],
            circlePoint: [],
            logPointArr: [
              {
                left: "1430.196",
                top: "1456.636",
              },
              {
                left: "1430.196",
                top: "1477.959",
              },
            ],
          },
          {
            spaceId: "unc",
            localName: "unc",
            canClick: true,
            pointArr: [],
            devicePoint: [],
            circlePoint: [
              {
                left: "2083.25",
                top: "1776.783",
              },
              {
                left: "2205.405",
                top: "1656.853",
              },
              {
                left: "1916.54",
                top: "1367.988",
              },
              {
                left: "2355.83",
                top: "928.6981",
              },
              {
                left: "2224.321",
                top: "797.1886",
              },
              {
                left: "2774.886",
                top: "246.625",
              },
              {
                left: "3054.136",
                top: "246.625",
              },
              {
                left: "3051.636",
                top: "2480.125",
              },
              {
                left: "2790.702",
                top: "2480.125",
              },
            ],
            logPointArr: [],
          },
        ];
        proxyData.copySpaceArr = JSON.stringify(spaceList);
        proxyData.formSpaceData();
      },

      /**
       * 获取地图信息
       */
      getMapInfo() {
        let params: any = {
          projectId: "Pj1101080259",
          floorId: "Fl11010802593241ec348ecb4148806b9034c8957454",
        };
        getMapInfo(params)
          .then((res) => {
            // debugger
            let resData: any = res;
            let data: any = resData?.data ?? null;
            proxyData.width = data.width;
            proxyData.height = data.height;
            proxyData.spaceList = data.spaceList;
            proxyData.setSpaceColor();
            proxyData.initCanvas();
          })
          .catch(() => {});
      },
    });
    nextTick(() => {
      proxyData.bindEvent();
    });
    onMounted(() => {
      // proxyData.getMapInfo();
      proxyData.formatePage();
      proxyData.initCanvas();
    });
    return {
      ...toRefs(proxyData),
    };
  },
});
